module.exports = __webpack_public_path__ + "img/button-gold.a6baec72.png";